import { render, staticRenderFns } from "./FreeHero.vue?vue&type=template&id=171a742c&scoped=true&"
import script from "./FreeHero.vue?vue&type=script&lang=js&"
export * from "./FreeHero.vue?vue&type=script&lang=js&"
import style0 from "./FreeHero.vue?vue&type=style&index=0&id=171a742c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171a742c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FreeMediaTypesDropdown: require('/opt/render/project/src/channels2022/src/components/free/FreeMediaTypesDropdown.vue').default,FreeHeroPartner: require('/opt/render/project/src/channels2022/src/components/free/FreeHeroPartner.vue').default})
